/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/public/blocks/new": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.public.blocks.create_new_block"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/geo/autocomplete_address": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.public.geo.autocomplete_address"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/geo/get_address_information": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.public.geo.get_address_information"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/occupation/types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Used by the frontend to receive the *public* occupation status selection */
        get: operations["v1.public.occupation.get_occupation_types"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/salary/types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Used by the frontend to receive the *public* salary status selection */
        get: operations["v1.public.salary.get_salary_types"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/contact-verification": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["v1.public.contact-verification.status"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/contact-verification/request": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.public.contact-verification.request"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/contact-verification/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Verify a contact
         * @description Needs no login, as the token from the mailed link proves access to the contact.
         */
        post: operations["v1.public.contact-verification.verify"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Closes (deletes) the authenticated user's own account */
        post: operations["v1.public.user.delete"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/email-change-confirmations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Confirm an email change
         * @description Needs no login, as the token from the mailed link proves access to the new email. The link expires after 30 minutes.
         */
        post: operations["v1.public.user.emailChangeConfirmations.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["v1.public.user.get_user_info"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/occupation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Used by the frontend to store the player's occupation */
        post: operations["v1.public.store_occupation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Update the authenticated player's own profile
         * @description Fields left out are not changed. A new email is not saved right away: the player gets a mail with a link
         *     they must follow within 30 minutes. Which fields may be changed depends on the site and the player.
         */
        put: operations["v1.public.user.profile.update"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/reality-check-setting": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["v1.public.user.reality_check_setting.show"];
        put?: never;
        post: operations["v1.public.user.reality_check_setting.store"];
        delete: operations["v1.public.user.reality_check_setting.destroy"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/salary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Used by the frontend to store the player's salary */
        post: operations["v1.public.store_salary"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/set-phone-number": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Set phone number for user */
        put: operations["v1.public.user.set_phone_number"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/set-phone-number-and-email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** Set phone number and/or email for user */
        put: operations["v1.public.user.set_phone_number_and_email"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.public.user.signup"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/user-edit-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Gets data needed for the user edit page */
        get: operations["v1.public.user.get_user_edit_data"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/user-report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** As user, request a user report1 */
        post: operations["v1.user.request_user_report_by_user"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/user-report/{playerReport}/download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** /* Download a user report as a ZIP file by user */
        get: operations["v1.user.get_user_download_by_user"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/user-report/{playerReport}/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get the download status of a user report */
        get: operations["v1.user.get_user_report_status"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/public/user/validate-signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["v1.public.user.validate_signup"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/blocks/active/user/{user}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.blocks.get_blocks_for_user"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/blocks/backoffice/block/remove/{blockId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description 🔒 **Required role:** `user-write` */
        post: operations["v1.blocks.backoffice.remove_block"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/blocks/backoffice/cooldown/{player}/new": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Allow other services and backoffice users to create a cooldown for a player of any length
         * @description 🔒 **Required role:** `user-write`
         */
        post: operations["v1.blocks.backoffice.create_new_cooldown"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/blocks/backoffice/player/{playerId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.blocks.backoffice.get_player_blocks"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/blocks/cooldown/{player}/new": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Allow other services and backoffice users to create a cooldown for a player of any length
         * @description 🔒 **Required role:** `user-write`
         */
        post: operations["v1.blocks.cooldown.create_new_cooldown"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/blocks/player-block": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Paginated list of player blocks with optional filtering via conditions
         * @description Allows other services to find players matching block criteria (e.g. all
         *     active deactivations) without forcing a cross-schema join from the site
         *     users table.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.blocks.player_block.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/blocks/player/{player}/remove-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Ends all active blocks of the given type for a player
         * @description 🔒 **Required role:** `user-write`
         */
        post: operations["v1.blocks.remove_all_blocks"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/blocks/player/{playerId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.blocks.get_all_blocks_for_player"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/blocks/reconcile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Counts the blocks created and ended in the period, per block type
         * @description Allows consumers of the block Kafka messages to verify that they received and stored every
         *     message for a period. The period is half-open, [from, to), so that adjacent periods neither
         *     overlap nor leave a gap.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.blocks.reconcile"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/data/{playerId}/audits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.data.audits"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/data/{playerId}/blocks": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.data.blocks"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/data/{playerId}/closed-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.data.closed_logs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/data/{playerId}/cooldowns": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.data.cooldowns"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/data/{playerId}/deactivated-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.data.deactivated_logs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/data/{playerId}/event-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.data.event_logs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/data/{playerId}/flag-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.data.flag_logs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/data/{playerId}/notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Notes about the player, newest first, optionally limited to a period
         * @description 🔒 **Required role:** `user-read`
         */
        get: operations["v1.data.notes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/data/{playerId}/suspension-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.data.suspension_logs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/flag": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets all flags from the player account database, with given fields and conditions
         * @description 🔒 **Required role:** `flag-read`
         */
        get: operations["v1.flag.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.player.index"];
        put?: never;
        /**
         * Store a newly created player in storage
         * @description 🔒 **Required role:** `user-write`
         */
        post: operations["v1.player.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player-event-log": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Store a newly created resource in storage
         * @description 🔒 **Required role:** `event-write`
         */
        post: operations["v1.player_event_log.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player-flag": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets all playerflags with given fields and conditions
         * @description 🔒 **Required role:** `flag-read`
         */
        get: operations["v1.player_flag.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player-flag-log": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets playerflaglogs with given fields and conditions
         * @description 🔒 **Required role:** `flag-read`
         */
        get: operations["v1.player_flag_log.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player-flag/{playerFlag}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Endpoint to delete a playerFlag entry based on its id, and its corresponding PlayerFlagLog
         * @description 🔒 **Required role:** `flag-write`
         */
        delete: operations["v1.player_flag.destroy"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Display the specified resource for a single player
         * @description 🔒 **Required role:** `user-read`
         */
        get: operations["v1.player.show"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/exclusion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.exclusion.get_status"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/flag/add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Endpoint to add a flag to a player
         * @description 🔒 **Required role:** `flag-write`
         */
        post: operations["v1.player.flag.add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/flag/remove": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Endpoint to remove a flag from a player
         * @description 🔒 **Required role:** `flag-write`
         */
        post: operations["v1.player.flag.remove"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/flags": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint to get all flags for a player
         * @description 🔒 **Required role:** `flag-read`
         */
        get: operations["v1.player.flag.get_flags"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/flags/{flagType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint to check if a player has a flag
         * @description 🔒 **Required role:** `flag-read`
         */
        get: operations["v1.player.flag.has_flag"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/flags/{flagType}/has-had": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `flag-read` */
        get: operations["v1.player.flag.has_had"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/get-all-users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint to get all user from a player_id
         * @description The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.player.get_all_users"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/get-newest-user": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint to return the newest created user for a player. Can return closed users!
         * @description The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.player.get_newest_user"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/get-oldest-user": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint to return the oldest created user for a player. Can return closed users!
         * @description The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.player.get_oldest_user"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/get-users-count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint to get the count of users for a player
         * @description 🔒 **Required role:** `user-read`
         */
        get: operations["v1.player.get_users_count"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/getactiveuser": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint to return the latest active, non-closed user for a player
         * @description The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.player.get_active_user"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/notes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Stores a note about a player, written from one of the player's users
         * @description 🔒 **Required role:** `user-write`
         */
        post: operations["v1.player.notes.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/{player}/player-event-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets all player event logs for a player
         * @description 🔒 **Required role:** `user-read`
         */
        get: operations["v1.player.get_all_player_event_logs_for_player"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/flag/add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description 🔒 **Required role:** `flag-write` */
        post: operations["v1.player.flag.batch_add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/flag/remove": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description 🔒 **Required role:** `flag-write` */
        post: operations["v1.player.flag.batch_remove"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/get-newest-users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Batch getNewestUsers
         * @description Endpoint to return the newest created uses for a list of players. Can return closed users!
         *
         *     The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.player.get_newest_users"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/occupation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Used by case-management, to save a players occupation from a case
         * @description 🔒 **Required role:** `report-access`
         */
        post: operations["v1.player.store_occupation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/occupation/{player}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets all occupations for a player
         * @description 🔒 **Required role:** `report-access`
         */
        get: operations["v1.player.get_occupations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/occupation/types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Used by case-management to receive all occupation status
         * @description 🔒 **Required role:** `report-access`
         */
        get: operations["v1.player.occupation.get_occupation_types"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/salary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Used by case-management, to save a players salary from a case
         * @description 🔒 **Required role:** `report-access`
         */
        post: operations["v1.player.store_salary"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/salary/{player}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the salary of a player
         * @description 🔒 **Required role:** `report-access`
         */
        get: operations["v1.player.get_salary"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/player/salary/types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Used by the frontend to receive the salary status selection
         * @description 🔒 **Required role:** `report-access`
         */
        get: operations["v1.player.salary.get_salary_types"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/segment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets all segments
         * @description 🔒 **Required role:** `segment-read`
         */
        get: operations["v1.segment.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/segment/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets a segment
         * @description 🔒 **Required role:** `segment-read`
         */
        get: operations["v1.segment.show"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/segment/{type}/player/{player}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * Removes segment from player
         * @description 🔒 **Required role:** `segment-write`
         */
        delete: operations["v1.segment.player.remove_segment"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/segment/{type}/players-count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets all players in a segment
         * @description 🔒 **Required role:** `segment-read`
         */
        get: operations["v1.segment.players_count"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/segment/{type}/user/{user}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * removes segment from user
         * @description 🔒 **Required role:** `segment-write`
         */
        delete: operations["v1.segment.user.remove_segment"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/segment/player": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Batch Adds segment to players
         * @description 🔒 **Required role:** `segment-write`
         */
        put: operations["v1.segment.player.batch_add_segment"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/segment/player/{player}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets segments for player
         * @description 🔒 **Required role:** `segment-read`
         */
        get: operations["v1.segment.player.get_segments"];
        /**
         * Adds segment to player
         * @description 🔒 **Required role:** `segment-write`
         */
        put: operations["v1.segment.player.add_segment"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/segment/user": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * Batch Adds segment to users
         * @description 🔒 **Required role:** `segment-write`
         */
        put: operations["v1.segment.user.batch_add_segment"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/segment/user/{user}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets segments for user
         * @description 🔒 **Required role:** `segment-read`
         */
        get: operations["v1.segment.user.get_segments"];
        /**
         * Adds segment to user
         * @description 🔒 **Required role:** `segment-write`
         */
        put: operations["v1.segment.user.add_segment"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Shows a paginated resource of all users
         * @description The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user-brand": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.user_brand.get"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user-brand/newest-users": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.user_brand.newest_users"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns a single user
         * @description The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.show"];
        /**
         * Update the specified resource in storage
         * @description 🔒 **Required role:** `user-write`
         */
        put: operations["v1.user.update"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/account-status-report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Generate and download a user's account status report as a PDF
         * @description 🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.accountStatusReport"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/event-logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all event_logs for a user
         * @description 🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.flag.get_event_logs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/flag-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint to get all flag resources for the user
         * @description 🔒 **Required role:** `flag-read`
         */
        get: operations["v1.user.flag.get_user_flag_data"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/flag-logs-data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Gets all flaglogs for a user
         * @description 🔒 **Required role:** `flag-read`
         */
        get: operations["v1.user.flag_logs_data"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/flag/add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Endpoint to add a flag to a user
         * @description 🔒 **Required role:** `flag-write`
         */
        post: operations["v1.user.flag.add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/flag/batch-add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch endpoint for adding multiple flags to the same user
         * @description 🔒 **Required role:** `flag-write`
         */
        post: operations["v1.user.flag.batch_add_to_user"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/flag/batch-remove": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch endpoint for removing multiple flags from the same user
         * @description 🔒 **Required role:** `flag-write`
         */
        post: operations["v1.user.flag.batch_remove_from_user"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/flag/remove": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Endpoint to remove a flag from a user
         * @description 🔒 **Required role:** `flag-write`
         */
        post: operations["v1.user.flag.remove"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/flags": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Endpoint to get all flags for the user
         * @description 🔒 **Required role:** `flag-read`
         */
        get: operations["v1.user.flag.get_flags"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/flags/{flagType}/has-had": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `flag-read` */
        get: operations["v1.user.flag.has_had"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/getallusersfromplayer": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns all users on the given user's player. Without `fields`, every field is returned
         * @description The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.get_all_users_from_player"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/incident": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Triggers an incident on a user
         * @description 🔒 **Required role:** `event-write`
         */
        post: operations["v1.user.incident.store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/payout-block": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns the payout block status of the user
         * @description 🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.payout_block"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/reports": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get all user reports for a user
         * @description 🔒 **Required role:** `report-access`
         */
        get: operations["v1.user.get_all_user_reports_for_user"];
        put?: never;
        /**
         * As admin, request a user report
         * @description 🔒 **Required role:** `report-access`
         */
        post: operations["v1.user.admin.request_user_report"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/reports/{playerReport}/download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * As admin download a user report
         * @description 🔒 **Required role:** `report-access`
         */
        get: operations["v1.user.get_user_report"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/signedup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Signup flow player account
         * @description 🔒 **Required role:** `user-write`
         */
        post: operations["v1.user.signed_up"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/similarity-check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns array of users and similarity score above threshold
         * @description 🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.get_similar_users"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/update-validation-status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description 🔒 **Required role:** `user-write` */
        post: operations["v1.user.updateUserValidationStatus"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{user}/username/generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Generate a new username for the user
         * @description The nameservice generates and registers the username, replacing the user's current one. Used by the backoffice.
         *
         *     🔒 **Required role:** `user-write`
         */
        post: operations["v1.user.username.generate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/{userId}/acl_attributes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description 🔒 **Required role:** `user-read` */
        get: operations["v1.user.acl_attributes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Bulk-fetch users by id, keyed by id. Same per-user shape as show()
         * @description The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     🔒 **Required role:** `user-read`
         */
        post: operations["v1.user.batch"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/flag/add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch endpoint for adding a flag to multiple users
         * @description 🔒 **Required role:** `flag-write`
         */
        post: operations["v1.user.flag.batch_add"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/flag/remove": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Batch endpoint for removing a flag from multiple users
         * @description 🔒 **Required role:** `flag-write`
         */
        post: operations["v1.user.flag.batch_remove"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/fully-anonymized": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Anonymized users whose player has no remaining non-anonymized user
         * @description Every user on the returned player ids is anonymized, so the player id itself no longer
         *     belongs to any customer. Cursor paginated in ascending id order; pass `next_cursor` back
         *     as `cursor` to walk all pages.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.fullyAnonymized"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/incident": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Triggers an incident on multiple users
         * @description 🔒 **Required role:** `event-write`
         */
        post: operations["v1.user.incident.batch_store"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/index-with-flags": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns a paginated resource of all users, with all info on all the users flags
         * @description The `ssn` field is only returned to callers holding the `ssn-access` role; for other callers it is replaced by `{"masked": true}`.
         *
         *     Note: unlike index() and show(), the items here are serialized straight off the model rather
         *     than through UserRepresentation. The DTO has no flag properties, so mapping through it would
         *     silently drop the `player_flags` tree (and the `flag.*` / `player_flag_log.*` field selectors
         *     this endpoint accepts), which is the only thing callers come here for.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.indexWithFlags"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Free-form search users
         * @description Results never include `ssn`. Searching by SSN (a full SSN or the `cpr:` prefix) is logged unless the caller holds the `ssn-access` role.
         *
         *     🔒 **Required role:** `user-read`
         */
        get: operations["v1.user.search"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @description 🔒 **Required role:** `user-write` */
        post: operations["v1.user.signup"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Update the specified resource in storage
         * @description 🔒 **Required role:** `user-write`
         */
        post: operations["v1.user.batch_update"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/v1/user/validate-signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Endpoint that runs a selected subset of validation rules for users trying to sign up
         * @description The validation result is used in monolith.
         *
         *     This means this endpoint facilitates moving parts of the validation logic out of the monolith.
         *
         *     The return value must be considered public, as it will be shown to the clients.
         *
         *     Once signup is moved out of monolith, this endpoint can be deleted.
         *
         *     The validation rules are defined on the UserSignupValidationRequest DTO, thus the controller is strictly empty.
         *
         *     🔒 **Required role:** `ssn-access`
         */
        post: operations["v1.user.validate_signup"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** AddressDetails */
        AddressDetails: {
            addressline: string | null;
            buildingname: string | null;
            county: string | null;
            dependentlocality: string | null;
            dependentstreet: string | null;
            organisation: string | null;
            postcode: string | null;
            posttown: string | null;
            premise: string | null;
            street: string | null;
            summaryline: string | null;
        };
        /** AddressSuggestion */
        AddressSuggestion: {
            /** @default 0 */
            count: number;
            id: string | null;
            locationsummary: string | null;
            summaryline: string | null;
            type: string | null;
        };
        /** AutocompleteAddressRequest */
        AutocompleteAddressRequest: {
            pathFilter?: string | null;
            searchString: string;
        };
        /**
         * BackendSignupRequestDto
         * @description Request body for the internal (service-to-service) signup endpoint.
         *
         *     Unlike the public SignupRequestDto this carries no captcha token and no
         *     device/session fields, and the password is optional — a backend caller may
         *     create a user without immediately setting a password.
         */
        BackendSignupRequestDto: {
            address?: string | null;
            birthdate?: string | null;
            campaignId?: number | null;
            city?: string | null;
            consentTexts?: components["schemas"]["SignupConsentTextsDto"] | null;
            email?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            partnerId?: number | null;
            partnerUserId?: string | null;
            password?: string | null;
            phone?: string | null;
            privacyPolicy?: boolean | null;
            selectedBundle?: number | null;
            ssn?: string | null;
            terms?: boolean | null;
            zipcode?: string | null;
        };
        /** BatchFlagsRequest */
        BatchFlagsRequest: {
            admin_user_id?: string;
            created_by_admin?: string | null;
            /** Format: date-time */
            expires_at?: string | null;
            reason?: string | null;
            /** Format: date-time */
            sent_at?: string | null;
            type?: string | null;
            types: [
                string,
                ...string[]
            ];
        };
        /** BatchPlayerFlagRequest */
        BatchPlayerFlagRequest: {
            /**
             * @description The admin user id that triggered the request
             * @default 0
             */
            admin_user_id?: number | null;
            /** @description The admin identifier that triggered the request */
            created_by_admin?: string | null;
            /**
             * Format: date-time
             * @description Time when the flag expires
             */
            expires_at?: string | null;
            /** @description The players ids to add flag to */
            player_ids: Record<string, never>[];
            /** @description The reason for the flag */
            reason?: string | null;
            /**
             * Format: date-time
             * @description When the flag was sent
             */
            sent_at?: string | null;
            /** @description The IP used when signing up */
            type: string;
        };
        /**
         * BatchPlayerSegmentRequest
         * @description Class SegmentRequest
         */
        BatchPlayerSegmentRequest: {
            player_ids: [
                string,
                ...string[]
            ];
            type: string;
        };
        /** BatchUpdateUserRequest */
        BatchUpdateUserRequest: {
            address?: string | null;
            /** @description This parameter is used in the Audit Log (Audit::execute()) */
            admin_user_id?: string;
            /** Format: date */
            birthdate?: string;
            birthyear?: number;
            city?: string | null;
            disable_updating_of_consent?: boolean;
            /** @description In special cases, we might want to disable updating of Marketing Automation */
            disable_updating_of_marketing_automation?: boolean;
            /**
             * Format: email
             * @description We support these attributes on the User model
             */
            email?: string;
            first_name?: string;
            last_name?: string;
            name?: string;
            phone?: string;
            user_ids: [
                number,
                ...number[]
            ];
            zipcode?: string;
        };
        /** BatchUserFlagRequest */
        BatchUserFlagRequest: {
            admin_user_id?: string;
            created_by_admin?: string | null;
            /** Format: date-time */
            expires_at?: string | null;
            reason?: string | null;
            /** Format: date-time */
            sent_at?: string | null;
            type: string;
            user_ids: [
                number,
                ...number[]
            ];
        };
        /**
         * BatchUserIncidentRequest
         * @description Class BatchUserIncidentRequest
         */
        BatchUserIncidentRequest: {
            admin_user_id?: string;
            created_by_admin?: string | null;
            payload?: string[] | null;
            reason?: string | null;
            sent_at?: string | null;
            type: string;
            user_ids: [
                number,
                ...number[]
            ];
        };
        /**
         * BatchUserSegmentRequest
         * @description Class SegmentRequest
         */
        BatchUserSegmentRequest: {
            type: string;
            user_ids: [
                number,
                ...number[]
            ];
        };
        /**
         * BlockCategory
         * @description Categories of reasons for blocking a player.
         * @enum {string}
         */
        BlockCategory: BlockCategory;
        /**
         * BlockDuration
         * @enum {string}
         */
        BlockDuration: BlockDuration;
        /** BlockRepresentation */
        BlockRepresentation: {
            brand: components["schemas"]["Brand"];
            /** Format: date-time */
            canBeRemovedAt: string;
            /** Format: date-time */
            createdAt: string;
            deleted: boolean;
            /** Format: date-time */
            deletedAt: string | null;
            /** Format: date-time */
            endtime: string | null;
            id: number;
            indefinite: boolean;
            /** Format: date-time */
            updatedAt: string;
            userId: number;
        };
        /**
         * BlockType
         * @enum {string}
         */
        BlockType: BlockType;
        /** BlockTypeCounts */
        BlockTypeCounts: {
            created: number;
            ended: number;
        };
        /**
         * Brand
         * @enum {string}
         */
        Brand: Brand;
        /** ConfirmEmailChangeRequest */
        ConfirmEmailChangeRequest: {
            /**
             * Format: uuid
             * @description The token from the link mailed to the new email
             */
            token: string;
        };
        /** ConfirmEmailChangeResponse */
        ConfirmEmailChangeResponse: {
            /** @description The player's email after the change */
            email: string;
        };
        /** ConsentTextDto */
        ConsentTextDto: {
            content?: string | null;
            version?: string | null;
        };
        /**
         * ContactType
         * @enum {string}
         */
        ContactType: ContactType;
        /** ContactVerificationResponse */
        ContactVerificationResponse: {
            code: components["schemas"]["PublicErrorCodes"] | null;
            /** @description A message describing the status, should not be shown to the user, can be used for debug. Is not a secret */
            message: string | null;
            /** @description The status of the contact verification request */
            status: string;
        };
        /** ContactVerificationStatusRequest */
        ContactVerificationStatusRequest: {
            /** @default email */
            type?: components["schemas"]["ContactType"];
        };
        /** ContactVerificationStatusResponse */
        ContactVerificationStatusResponse: {
            contact_value: string | null;
            is_verified: boolean;
            type: components["schemas"]["ContactType"];
            /** Format: date-time */
            verified_at: string | null;
        };
        /** CooldownRepresentation */
        CooldownRepresentation: {
            brand: components["schemas"]["Brand"];
            /** Format: date-time */
            createdAt: string;
            createdBy: string | null;
            /** Format: date-time */
            endtime: string;
            id: number;
            processed: boolean;
            reason: string;
            /** Format: date-time */
            updatedAt: string;
            userId: number;
        };
        /** DateIntervalRequest */
        DateIntervalRequest: {
            /** Format: date-time */
            from: string;
            /** Format: date-time */
            to: string;
        };
        /** DeleteUserResponse */
        DeleteUserResponse: {
            /** @description A message describing the outcome, should not be shown to the user, can be used for debug. Is not a secret */
            message: string;
            /** @description Whether the account was closed */
            success: boolean;
        };
        /** ExclusionStatusResponse */
        ExclusionStatusResponse: {
            block: string | null;
            cooldown: string | null;
        };
        /** FieldsRequest */
        FieldsRequest: {
            /** @default [] */
            fields?: string[];
        };
        /** Flag */
        Flag: {
            add_condition: string;
            /** Format: date-time */
            created_at: string | null;
            description: string;
            effect: string;
            icon: string;
            icon_full_path: string;
            id: number;
            name: string;
            owner: string;
            require_reason: number;
            slug: string;
            type: string;
            /** Format: date-time */
            updated_at: string | null;
        };
        /** FlagRepresentation */
        FlagRepresentation: {
            addCondition: string;
            description: string;
            effect: string;
            id: number;
            name: string;
            owner: string;
            type: string;
        };
        /** FullyAnonymizedUsersQueryData */
        FullyAnonymizedUsersQueryData: {
            /** @description Opaque cursor from a previous page's `next_cursor` */
            cursor?: string | null;
            /** @default 1000 */
            perPage?: number;
        };
        /** GeneratedUsernameResponse */
        GeneratedUsernameResponse: {
            /** @description The username the nameservice generated and registered for the user */
            username: string;
        };
        /** GetAddressInformationRequest */
        GetAddressInformationRequest: {
            addressId: string;
            searchString: string;
        };
        /** GetBlocksResponse */
        GetBlocksResponse: {
            blocks: components["schemas"]["PresentedBlock"][];
            cooldowns: components["schemas"]["PresentedCooldown"][];
            deactivations: components["schemas"]["PresentedDeactivation"][];
            suspensions: components["schemas"]["PresentedSuspension"][];
        };
        /** GetSalaryOptionsResponse */
        GetSalaryOptionsResponse: {
            from: number;
            id: number;
            label: string | null;
            to: number | null;
        };
        /** GetSalaryResponse */
        GetSalaryResponse: {
            player_id: string;
            salaries: components["schemas"]["SalaryRepresentation"][];
        };
        /** GetUserInfoRequest */
        GetUserInfoRequest: {
            brand?: components["schemas"]["Brand"] | null;
        };
        /** HasHadFlagResponse */
        HasHadFlagResponse: {
            /**
             * Format: date-time
             * @description When the user first had the flag
             */
            firstAdded: string | null;
            /** @description If the user has had the flag at any point in time */
            hasHadFlag: boolean;
        };
        /** LegacyUser */
        LegacyUser: {
            address: string | null;
            anonymized: boolean | null;
            birthdate: string | null;
            city: string | null;
            closed: boolean;
            /** Format: date-time */
            created: string;
            customer_number: string;
            email: string;
            first_name: string | null;
            id: number;
            is_staff: number | null;
            /** Format: date-time */
            last_login: string | null;
            last_name: string | null;
            /** Format: date-time */
            modified: string;
            name: string;
            phone: string | null;
            phone_prefix: string;
            /** Format: uuid */
            player_id: string | null;
            sex: string | null;
            ssn: string;
            user_validation_status_id: number;
            zipcode: string | null;
        };
        /** MaskedData */
        MaskedData: {
            masked: boolean;
        };
        /** NewCooldownRequest */
        NewCooldownRequest: {
            brand?: components["schemas"]["Brand"] | null;
            category: components["schemas"]["BlockCategory"];
            /** Format: date-time */
            expiresAt: string;
            onBehalfOfAdminUser?: string | null;
            reason: string;
        };
        /** OccupationRequest */
        OccupationRequest: {
            company_name?: string | null;
            created_by?: string | null;
            findings?: string | null;
            /** @default false */
            high_risk_occupation?: boolean;
            job_title?: string | null;
            occupation_status?: string | null;
            player_id: string;
        };
        /** PartnerDataDto */
        PartnerDataDto: {
            campaign_id?: number | null;
            campaign_name?: string | null;
            partner_id?: number | null;
            partner_name?: string | null;
            partner_user_id?: string | null;
        };
        /** Player */
        Player: {
            /** Format: date-time */
            created_at: string | null;
            /** Format: uuid */
            id: string;
            /** Format: date-time */
            updated_at: string | null;
        };
        /** PlayerBlock */
        PlayerBlock: {
            brand: components["schemas"]["Brand"] | null;
            category: components["schemas"]["BlockCategory"];
            /** Format: date-time */
            created_at: string;
            created_by_admin: string | null;
            created_by_authed_admin: string | null;
            created_by_user_id: number | null;
            /** Format: date-time */
            ended_at: string | null;
            ended_by_admin: string | null;
            ended_reason: string | null;
            /** Format: date-time */
            expires_at: string | null;
            id: number;
            imported_id: number | null;
            /** Format: uuid */
            player_id: string;
            reason: string;
            type: components["schemas"]["BlockType"];
            /** Format: date-time */
            updated_at: string;
        };
        /** PlayerEventLog */
        PlayerEventLog: {
            /** Format: date-time */
            created_at: string;
            created_by: number;
            id: number;
            player_id: string;
            reason: string | null;
            type: components["schemas"]["PlayerEventLogType"];
            user_id: number;
        };
        /** PlayerEventLogsRepresentation */
        PlayerEventLogsRepresentation: {
            /** Format: date-time */
            createdAt: string;
            createdBy: string | null;
            id: number;
            playerId: string;
            reason: string | null;
            type: number;
            userId: number;
        };
        /**
         * PlayerEventLogType
         * @enum {integer}
         */
        PlayerEventLogType: PlayerEventLogType;
        /** PlayerFlagLog */
        PlayerFlagLog: {
            /** Format: date-time */
            created_at: string | null;
            created_by: number;
            created_by_admin: string | null;
            flag_id: number;
            id: number;
            player_id: string;
            reason: string | null;
            type: components["schemas"]["PlayerFlagLogType"];
            /** Format: date-time */
            updated_at: string | null;
        };
        /** PlayerFlagLogsRepresentation */
        PlayerFlagLogsRepresentation: {
            added: boolean;
            /** Format: date-time */
            createdAt: string | null;
            createdBy: string | null;
            flag: components["schemas"]["FlagRepresentation"];
            id: number;
            playerId: string;
            reason: string | null;
            /** Format: date-time */
            updatedAt: string | null;
            userId: number;
        };
        /**
         * PlayerFlagLogType
         * @enum {integer}
         */
        PlayerFlagLogType: PlayerFlagLogType;
        /** PlayerIndexRequest */
        PlayerIndexRequest: {
            /**
             * @default [
             *       "*"
             *     ]
             */
            fields?: string[];
            /** @default 1 */
            page?: number;
            /** @default 1000 */
            perPage?: number;
            /** @default true */
            withNewestUser?: boolean;
        };
        /** PlayerNotesRepresentation */
        PlayerNotesRepresentation: {
            body: string;
            /** Format: date-time */
            createdAt: string | null;
            createdBy: string | null;
            id: number;
            playerId: string;
            userId: number;
        };
        /** PlayerReport */
        PlayerReport: {
            admin_id: number | null;
            brand: components["schemas"]["Brand"];
            /** Format: date-time */
            created_at: string | null;
            downloaded: boolean;
            file: string | null;
            id: number;
            requested_by_admin: boolean;
            state: components["schemas"]["PlayerReportStateTypes"];
            token: string | null;
            /** Format: date-time */
            token_expires_at: string | null;
            /** Format: date-time */
            updated_at: string | null;
            user_id: number;
        };
        /** PlayerReportByAdminRequest */
        PlayerReportByAdminRequest: {
            admin_id: number;
            /** @default false */
            send_email?: boolean;
        };
        /**
         * PlayerReportStateTypes
         * @enum {string}
         */
        PlayerReportStateTypes: PlayerReportStateTypes;
        /** PresentedBlock */
        PresentedBlock: {
            appliedByAdmin: string | null;
            appliedByUserId: number | null;
            canBeRemoved: boolean;
            /** Format: date-time */
            canBeRemovedAt: string;
            /** Format: date-time */
            createdAt: string;
            durationSeconds: number | null;
            /** Format: date-time */
            endedAt: string | null;
            endedBy: string | null;
            endedReason: string | null;
            /** Format: date-time */
            expiresAt: string | null;
            id: number;
            isActive: boolean;
            reason: string;
            /** @default block */
            type: components["schemas"]["BlockType"];
            /** Format: date-time */
            updatedAt: string;
        };
        /** PresentedCooldown */
        PresentedCooldown: {
            appliedByAdmin: string | null;
            appliedByUserId: number | null;
            /** Format: date-time */
            createdAt: string;
            durationSeconds: number | null;
            /** Format: date-time */
            endedAt: string | null;
            endedBy: string | null;
            endedReason: string | null;
            /** Format: date-time */
            expiresAt: string | null;
            id: number;
            isActive: boolean;
            reason: string;
            /** @default cooldown */
            type: components["schemas"]["BlockType"];
            /** Format: date-time */
            updatedAt: string;
        };
        /** PresentedDeactivation */
        PresentedDeactivation: {
            appliedByAdmin: string | null;
            appliedByUserId: number | null;
            /** Format: date-time */
            createdAt: string;
            durationSeconds: number | null;
            /** Format: date-time */
            endedAt: string | null;
            endedBy: string | null;
            endedReason: string | null;
            /** Format: date-time */
            expiresAt: string | null;
            id: number;
            isActive: boolean;
            reason: string;
            /** @default deactivation */
            type: components["schemas"]["BlockType"];
            /** Format: date-time */
            updatedAt: string;
        };
        /** PresentedSuspension */
        PresentedSuspension: {
            appliedByAdmin: string | null;
            appliedByUserId: number | null;
            /** Format: date-time */
            createdAt: string;
            durationSeconds: number | null;
            /** Format: date-time */
            endedAt: string | null;
            endedBy: string | null;
            endedReason: string | null;
            /** Format: date-time */
            expiresAt: string | null;
            id: number;
            isActive: boolean;
            reason: string;
            /** @default suspension */
            type: components["schemas"]["BlockType"];
            /** Format: date-time */
            updatedAt: string;
        };
        /** ProfileValidationErrorResponse */
        ProfileValidationErrorResponse: {
            code: components["schemas"]["PublicErrorCodes"];
            /** @description Translated messages that can be shown to the player, keyed by request field name */
            failures: {
                [key: string]: string[];
            };
            message: string;
        };
        /**
         * PublicErrorCodes
         * @enum {string}
         */
        PublicErrorCodes: PublicErrorCodes;
        /** PublicErrorResponse */
        PublicErrorResponse: {
            /** @description A code describing the error, can be shown to the user, but best used to generate a message from the frontend */
            code: components["schemas"]["PublicErrorCodes"];
            /** @description A message describing the error, should not be shown to the user, can be used for debug. Is not a secret */
            message: string;
        };
        /** PublicNewBlockRequest */
        PublicNewBlockRequest: {
            blockDuration: components["schemas"]["BlockDuration"];
            brand: components["schemas"]["Brand"];
            type: components["schemas"]["BlockType"];
        };
        /** PublicOccupationRequest */
        PublicOccupationRequest: {
            occupation_status?: string | null;
        };
        /** PublicSalaryRequest */
        PublicSalaryRequest: {
            salary_id: number;
        };
        /** RealityCheckSettingData */
        RealityCheckSettingData: {
            /** @description The amount of minutes between each reality check, or 'inf' for unlimited */
            intervalMinutes: string;
        };
        /** RealityCheckSettingDataRequest */
        RealityCheckSettingDataRequest: {
            /** @description The amount of minutes between each reality check, or 'inf' for unlimited */
            intervalMinutes: string;
        };
        /** RemoveAllBlocksRequest */
        RemoveAllBlocksRequest: {
            onBehalfOfAdminUser?: string | null;
            reason: string;
            type: components["schemas"]["BlockType"];
        };
        /** RequestContactVerificationRequest */
        RequestContactVerificationRequest: {
            brand: components["schemas"]["Brand"];
            /** @description Only email for now; phone will be verified through another flow */
            type: components["schemas"]["ContactType"];
        };
        /** SalaryRepresentation */
        SalaryRepresentation: {
            /** Format: date-time */
            created_at: string;
            from: number;
            salary_id: number;
            to: number | null;
        };
        /** SalaryRequest */
        SalaryRequest: {
            created_by?: string | null;
            player_id: string;
            salary_id: number;
        };
        /** Segment */
        Segment: {
            /** Format: date-time */
            created_at: string | null;
            description: string;
            hex_color: string;
            id: number;
            type: string;
            /** Format: date-time */
            updated_at: string | null;
        };
        /**
         * SegmentRequest
         * @description Class SegmentRequest
         */
        SegmentRequest: {
            type: string;
        };
        /** SetPhoneNumberAndEmailRequest */
        SetPhoneNumberAndEmailRequest: {
            email?: string | null;
            phone?: string | null;
        };
        /** SetPhoneNumberAndEmailResponse */
        SetPhoneNumberAndEmailResponse: {
            code: components["schemas"]["PublicErrorCodes"] | null;
            /** @description A message describing the status of the edit request, should not be shown to the user, can be used for debug. Is not a secret */
            message: string | null;
            /** @description The status of the edit request */
            status: string;
        };
        /** SetPhoneNumberRequest */
        SetPhoneNumberRequest: {
            /** @description The phone number to set */
            phone: string;
        };
        /** SetPhoneNumberResponse */
        SetPhoneNumberResponse: {
            code: components["schemas"]["PublicErrorCodes"] | null;
            /** @description A message describing the status of the edit request, should not be shown to the user, can be used for debug. Is not a secret */
            message: string | null;
            /** @description The status of the edit request */
            status: string;
        };
        /** SignupConsentTextsDto */
        SignupConsentTextsDto: {
            generalTerms?: components["schemas"]["ConsentTextDto"] | null;
            privacyPolicy?: components["schemas"]["ConsentTextDto"] | null;
        };
        /** SignupRequestDto */
        SignupRequestDto: {
            address?: string | null;
            birthdate?: string | null;
            bundleAccepted?: boolean | null;
            campaignId?: number | null;
            captchaToken?: string | null;
            city?: string | null;
            consentTexts?: components["schemas"]["SignupConsentTextsDto"] | null;
            deviceFingerprint?: string | null;
            deviceType?: string | null;
            email?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            oneIdState?: string | null;
            partnerId?: number | null;
            partnerUserId?: string | null;
            password: string;
            phone?: string | null;
            privacyPolicy?: boolean | null;
            promotionAccepted?: boolean | null;
            /** Format: uuid */
            promotionId?: string | null;
            selectedBundle?: number | null;
            ssn?: string | null;
            terms?: boolean | null;
            userAgent?: string | null;
            /** @default [] */
            userAgentClientHints?: {
                [key: string]: unknown;
            };
            zipcode?: string | null;
        };
        /** SignupResponse */
        SignupResponse: {
            nonce: string | null;
            player_id: string;
            user_id: number;
        };
        /** SignupValidationMetaDto */
        SignupValidationMetaDto: {
            privacyPolicy?: boolean | null;
            terms?: boolean | null;
        };
        /** StorePlayerEventLogRequest */
        StorePlayerEventLogRequest: {
            reason?: string | null;
            type: components["schemas"]["PlayerEventLogType"];
            user_id: number;
        };
        /** StorePlayerNoteRequest */
        StorePlayerNoteRequest: {
            /** @description The monolith admin user writing the note, when the caller is the monolith */
            admin_user_id?: number | null;
            body: string;
            /** @description The identifier of the employee writing the note; defaults to the authenticated user */
            created_by_admin?: string | null;
            /** @description The user the note was written from; must belong to the player in the route */
            user_id: number;
        };
        /**
         * StorePlayerRequest
         * @description Class StorePlayerRequest
         */
        StorePlayerRequest: {
            id?: string;
        };
        /** StoreSalaryResponse */
        StoreSalaryResponse: {
            player_id: string;
            saved_salary: components["schemas"]["SalaryRepresentation"];
        };
        /** StoreUserReportRequest */
        StoreUserReportRequest: {
            brand: components["schemas"]["Brand"];
        };
        /**
         * UpdateProfileRequest
         * @description Fields left out are not changed, fields sent as null or empty are cleared.
         */
        UpdateProfileRequest: {
            address?: string | null;
            birthdate?: string | null;
            brand: components["schemas"]["Brand"];
            city?: string | null;
            email?: string | null;
            firstName?: string | null;
            /** @default false */
            forceEdit?: boolean;
            lastName?: string | null;
            name?: string | null;
            phone?: string | null;
            username?: string | null;
            zipcode?: string | null;
        };
        /** UpdateProfileResponse */
        UpdateProfileResponse: {
            /** @description Whether a mail was sent to the new email, which the player must confirm within 30 minutes before the email changes */
            emailChangeRequested: boolean;
        };
        /** UpdateUserRequest */
        UpdateUserRequest: {
            address?: string | null;
            /** @description This parameter is used in the Audit Log (Audit::execute()) */
            admin_user_id?: string;
            /** Format: date */
            birthdate?: string;
            birthyear?: number;
            city?: string | null;
            disable_updating_of_consent?: boolean;
            /** @description In special cases, we might want to disable updating of Marketing Automation */
            disable_updating_of_marketing_automation?: boolean;
            /**
             * Format: email
             * @description We support these attributes on the User model
             */
            email?: string;
            first_name?: string;
            last_name?: string;
            name?: string;
            phone?: string;
            zipcode?: string;
        };
        /** UpdateUserValidationStatusRequest */
        UpdateUserValidationStatusRequest: {
            on_behalf_of?: string | null;
            validationStatus: components["schemas"]["UserValidationStatus"];
        };
        /** UserAclAttributes */
        UserAclAttributes: {
            /** Format: date-time */
            blockEndTime: string | null;
            /** Format: date-time */
            cooldownEndTime: string | null;
            isBlocked: boolean;
            isCooldowned: boolean;
            isDeactivated: boolean;
            isStaff: boolean;
            isSuspended: boolean;
            /** Format: date-time */
            userCreatedAt: string;
        };
        /** UserAuditsRepresentation */
        UserAuditsRepresentation: {
            /** Format: date-time */
            createdAt: string | null;
            event: string;
            id: string;
            newValue: string | null;
            oldValue: string | null;
            propertyName: string | null;
            userId: number;
        };
        /** UserAuditsRequest */
        UserAuditsRequest: {
            /** Format: date-time */
            from?: string | null;
            properties?: string[] | null;
            /** Format: date-time */
            to?: string | null;
        };
        /** UserBatchRequest */
        UserBatchRequest: {
            /**
             * @default [
             *       "*"
             *     ]
             */
            fields?: string[];
            user_ids: number[];
        };
        /** UserBatchResponse */
        UserBatchResponse: {
            data: components["schemas"]["UserRepresentation"][];
        };
        /** UserBrand */
        UserBrand: {
            brand: components["schemas"]["Brand"];
            /** Format: date-time */
            first_login: string;
            id: number;
            /** Format: date-time */
            latest_login: string;
            user_id: number;
        };
        /** UserBrandIndexRequest */
        UserBrandIndexRequest: {
            brand?: components["schemas"]["Brand"] | null;
            /** Format: date-time */
            from?: string | null;
            /** @default 1 */
            page?: number;
            /** @default 1000 */
            perPage?: number;
            /** @default DESC */
            sortOrder?: string;
            /** Format: date-time */
            to?: string | null;
        };
        /** UserBrandRequest */
        UserBrandRequest: {
            userIds: number[];
        };
        /** UserBrandResponse */
        UserBrandResponse: {
            brand: components["schemas"]["Brand"];
            /**
             * Format: date-time
             * @description The timestamp of the first login for the user on the given brand
             */
            firstLogin: string;
            /**
             * Format: date-time
             * @description The timestamp of the last login for the user on the given brand
             */
            latestLogin: string;
            userId: number;
        };
        /** UserCheckResult */
        UserCheckResult: {
            /**
             * @description Additional context for the check result, such as block end time, suspended date, etc
             * @default []
             */
            context: {
                [key: string]: unknown;
            };
            /** @description The type of user check result */
            type: components["schemas"]["UserCheckResultType"];
        };
        /**
         * UserCheckResultType
         * @enum {string}
         */
        UserCheckResultType: UserCheckResultType;
        /** UserClosedLogsRepresentation */
        UserClosedLogsRepresentation: {
            /** Format: date-time */
            createdAt: string | null;
            createdBy: string | null;
            id: number;
            reason: string | null;
            /** Format: date-time */
            updatedAt: string | null;
            userId: number;
        };
        /** UserEditDataResponse */
        UserEditDataResponse: {
            /** @description The pending email address for the user */
            pendingEmail: string | null;
            /** @description Whether the user has rejected advertisements through a gambling authority */
            rejectedAdvertisement: boolean;
        };
        /** UserFlagDataFlagRepresentation */
        UserFlagDataFlagRepresentation: {
            add_condition: string;
            description: string;
            effect: string;
            icon: string;
            id: number;
            name: string;
            owner: string;
            type: string;
        };
        /** UserFlagDataLogRepresentation */
        UserFlagDataLogRepresentation: {
            created_by: number;
            id: number;
            reason: string | null;
        };
        /** UserFlagDataPlayerFlagRepresentation */
        UserFlagDataPlayerFlagRepresentation: {
            /** Format: date-time */
            created_at: string | null;
            /** Format: date-time */
            expires_at: string | null;
            id: number;
            player_id: string;
        };
        /** UserFlagDataRepresentation */
        UserFlagDataRepresentation: {
            flag: components["schemas"]["UserFlagDataFlagRepresentation"];
            playerFlag: components["schemas"]["UserFlagDataPlayerFlagRepresentation"];
            playerFlagLog: components["schemas"]["UserFlagDataLogRepresentation"];
        };
        /**
         * UserFlagRequest
         * @description Class UserFlagRequest
         */
        UserFlagRequest: {
            admin_user_id?: string;
            created_by_admin?: string | null;
            /** Format: date-time */
            expires_at?: string | null;
            reason?: string | null;
            /** Format: date-time */
            sent_at?: string | null;
            type: string;
        };
        /**
         * UserIncidentRequest
         * @description Class UserIncidentRequest
         */
        UserIncidentRequest: {
            admin_user_id?: string;
            created_by_admin?: string | null;
            payload?: string[] | null;
            reason?: string | null;
            sent_at?: string | null;
            type: string;
        };
        /** UserInfoResponse */
        UserInfoResponse: {
            address: string | null;
            /**
             * @description Birthdate of the user in ISO 8601 format
             * @example 1990-01-01
             */
            birthDate: string | null;
            checkResult: components["schemas"]["UserCheckResult"] | null;
            city: string | null;
            /** Format: date-time */
            createdAt: string;
            customerNumber: string;
            email: string;
            firstName: string | null;
            fullName: string;
            id: number;
            /** @description Is the user blocked from making payouts */
            isPayoutBlocked: boolean;
            isStaff: boolean;
            isValidated: boolean;
            lastName: string | null;
            nthLogin: number;
            nthLoginForBrand: number;
            phone: string | null;
            playerId: string;
            sessionId: number;
            /** @description True if the user's first brand (per UserBrand) is different from the brand the request was made for */
            wasSoftSignedUp: boolean;
            zipcode: string | null;
        };
        /** UserPeriodRequest */
        UserPeriodRequest: {
            /** Format: date-time */
            from?: string | null;
            /** Format: date-time */
            to?: string | null;
        };
        /**
         * UserRepresentation
         * @description DTO class for the LegacyUser-model.
         *
         *     Most properties are nullable, as specifying $fields in the query will return a minimal set of fields.
         *
         *     Timestamps are serialized as `Y-m-d\TH:i:s\Z` in UTC, matching what LegacyUser::serializeDate()
         *     emitted before this DTO existed. The format is pinned per-property rather than through
         *     `config('data.date_format')`, because that config is global: it would change the wire format of
         *     every other Data object in the service - HTTP responses and Kafka payloads alike - and, since
         *     DateTimeInterfaceCast reads the same key, would also stop inbound DTOs parsing ISO-8601 offsets.
         */
        UserRepresentation: {
            address: string | null;
            anonymized: boolean | null;
            /** @description Birthdate in the format "YYYY-MM-DD". */
            birthdate: string | null;
            /** @description Indicates if the user is blocked. Only included if fields include "blocked". */
            blocked: boolean | null;
            city: string | null;
            closed: boolean;
            /** Format: date-time */
            created: string | null;
            /** @description Always included - Unique customer number assigned to the user. */
            customer_number: string;
            /** @description Indicates if the user is deactivated. Only included if fields include "deactivated". */
            deactivated: boolean | null;
            email: string | null;
            /** @description Only applies on HT - will always be null on SN. */
            first_name: string | null;
            /** @description Always included - the unique identifier of the user. */
            id: number;
            is_staff: number | null;
            /** Format: date-time */
            last_closed_at: string | null;
            /** Format: date-time */
            last_login: string | null;
            /** @description Only applies on HT - will always be null on SN. */
            last_name: string | null;
            /** Format: date-time */
            modified: string | null;
            /** @description Full name of the user. This field is available on both HT and SN. */
            name: string;
            /** @description Indicates if the user is blocked. Only included if fields include "on_cooldown". */
            on_cooldown: boolean | null;
            phone: string | null;
            phone_prefix: string | null;
            /**
             * Format: uuid
             * @description Always included - The UUID of the player associated with the user.
             */
            player_id: string | null;
            /** @description Can be either "m" (male) or "f" (female). */
            sex: string | null;
            /** @description Replaced by `{"masked": true}` for callers without the `ssn-access` role. */
            ssn: string | components["schemas"]["MaskedData"] | null;
            suspended: boolean | null;
            /**
             * @description 2. NEEDS_VALIDATION
             *     3. VALIDATED
             *     4. VALIDATION_FAILED
             *     5. VALIDATION_PENDING.
             *
             *     1. UNVALIDATED
             *     2. NEEDS_VALIDATION
             *     3. VALIDATED
             *     4. VALIDATION_FAILED
             *     5. VALIDATION_PENDING
             */
            user_validation_status_id: number | null;
            username: string | null;
            zipcode: string | null;
        };
        /** UserSearchRequest */
        UserSearchRequest: {
            search: string;
        };
        /** UserSignedUpRequest */
        UserSignedUpRequest: {
            /** @description The brand the user signed up with */
            brand: string;
            /** @description The bundle id the user signed up with */
            bundle_id?: number | null;
            /** @description The IP used when signing up */
            ip?: string | null;
            partner_data?: components["schemas"]["PartnerDataDto"] | null;
            /**
             * Format: uuid
             * @description A pre-generated player id to use instead of creating a new one
             */
            player_id?: string | null;
        };
        /** UserSignupDto */
        UserSignupDto: {
            address?: string | null;
            birthdate?: string | null;
            city?: string | null;
            email?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            meta?: components["schemas"]["SignupValidationMetaDto"] | null;
            password?: string | null;
            phone?: string | null;
            ssn?: string | null;
            username?: string | null;
            zipcode?: string | null;
        };
        /**
         * UserSignupValidationRequest
         * @description This class contains the current subset of validation rules that are handled in PA instead of monolith, as part of the ongoing effort to migrate validation logic.
         */
        UserSignupValidationRequest: {
            ssn: string;
        };
        /**
         * UserValidationStatus
         * @enum {integer}
         */
        UserValidationStatus: UserValidationStatus;
        /** ValidateSignupResponse */
        ValidateSignupResponse: {
            /**
             * @description Stable SignupFailureReason codes for the failures that have one, keyed by field like
             *     failures. A field can appear in failures without appearing here
             */
            failureReasons: {
                [key: string]: string[];
            };
            failures: {
                address?: string[];
                birthdate?: string[];
                city?: string[];
                email?: string[];
                firstName?: string[];
                lastName?: string[];
                password?: string[];
                phone?: string[];
                privacyPolicy?: string[];
                ssn?: string[];
                terms?: string[];
                username?: string[];
                zipcode?: string[];
            };
            meta: {
                existingUser?: {
                    canReopen: boolean;
                    exists: boolean;
                    /** @enum {string|null} */
                    matchedField: "ssn" | "email" | "phone" | null;
                    onCurrentBrand: boolean;
                    /** @enum {string|null} */
                    reopenMatchedField: "ssn" | "email" | "phone" | null;
                };
                isEligibleForSignup?: boolean;
            };
        };
        /** VerifyContactRequest */
        VerifyContactRequest: {
            /** Format: uuid */
            token: string;
        };
    };
    responses: {
        /** @description Authorization error */
        AuthorizationException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Not found */
        ModelNotFoundException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description Error overview. */
                    message: string;
                };
            };
        };
        /** @description Validation error */
        ValidationException: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": {
                    /** @description A detailed description of each field that failed validation. */
                    errors: {
                        [key: string]: string[];
                    };
                    /** @description Errors overview. */
                    message: string;
                };
            };
        };
    };
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    "v1.public.blocks.create_new_block": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `PublicNewBlockRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["PublicNewBlockRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.public.geo.autocomplete_address": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `AutocompleteAddressRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["AutocompleteAddressRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        items: components["schemas"]["AddressSuggestion"][];
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        code: string;
                        /** @constant */
                        message: "Address provider is unavailable";
                    };
                };
            };
        };
    };
    "v1.public.geo.get_address_information": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `GetAddressInformationRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["GetAddressInformationRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        items: components["schemas"]["AddressDetails"][];
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        code: string;
                        /** @constant */
                        message: "Address provider is unavailable";
                    };
                };
            };
        };
    };
    "v1.public.occupation.get_occupation_types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string;
                };
            };
        };
    };
    "v1.public.salary.get_salary_types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetSalaryOptionsResponse"][];
                };
            };
        };
    };
    "v1.public.contact-verification.status": {
        parameters: {
            query?: {
                type?: components["schemas"]["ContactType"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ContactVerificationStatusResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ContactVerificationStatusResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.public.contact-verification.request": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `RequestContactVerificationRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RequestContactVerificationRequest"];
            };
        };
        responses: {
            /** @description `ContactVerificationResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ContactVerificationResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.public.contact-verification.verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `VerifyContactRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["VerifyContactRequest"];
            };
        };
        responses: {
            /** @description `ContactVerificationResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ContactVerificationResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.public.user.delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `DeleteUserResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["DeleteUserResponse"];
                };
            };
            /** @description `PublicErrorResponse` */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PublicErrorResponse"];
                };
            };
        };
    };
    "v1.public.user.emailChangeConfirmations.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `ConfirmEmailChangeRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ConfirmEmailChangeRequest"];
            };
        };
        responses: {
            /** @description `ConfirmEmailChangeResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConfirmEmailChangeResponse"];
                };
            };
            /** @description `PublicErrorResponse` */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PublicErrorResponse"];
                };
            };
        };
    };
    "v1.public.user.get_user_info": {
        parameters: {
            query?: {
                brand?: components["schemas"]["Brand"] | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `UserInfoResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserInfoResponse"];
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.public.store_occupation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `PublicOccupationRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["PublicOccupationRequest"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Invalid occupation provided.";
                    };
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.public.user.profile.update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `UpdateProfileRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateProfileRequest"];
            };
        };
        responses: {
            /** @description `UpdateProfileResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UpdateProfileResponse"];
                };
            };
            /** @description `PublicErrorResponse` */
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PublicErrorResponse"];
                };
            };
            /** @description `ProfileValidationErrorResponse` */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ProfileValidationErrorResponse"];
                };
            };
        };
    };
    "v1.public.user.reality_check_setting.show": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `RealityCheckSettingData` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RealityCheckSettingData"];
                };
            };
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "v1.public.user.reality_check_setting.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `RealityCheckSettingDataRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RealityCheckSettingDataRequest"];
            };
        };
        responses: {
            /** @description `RealityCheckSettingData` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["RealityCheckSettingData"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.public.user.reality_check_setting.destroy": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
        };
    };
    "v1.public.store_salary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `PublicSalaryRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["PublicSalaryRequest"];
            };
        };
        responses: {
            /** @description `StoreSalaryResponse` */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StoreSalaryResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.public.user.set_phone_number": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `SetPhoneNumberRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SetPhoneNumberRequest"];
            };
        };
        responses: {
            /** @description `SetPhoneNumberResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SetPhoneNumberResponse"];
                };
            };
            /** @description `SetPhoneNumberResponse` */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SetPhoneNumberResponse"];
                };
            };
        };
    };
    "v1.public.user.set_phone_number_and_email": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `SetPhoneNumberAndEmailRequest` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SetPhoneNumberAndEmailRequest"];
            };
        };
        responses: {
            /** @description `SetPhoneNumberAndEmailResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SetPhoneNumberAndEmailResponse"];
                };
            };
            /** @description `SetPhoneNumberAndEmailResponse` */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SetPhoneNumberAndEmailResponse"];
                };
            };
        };
    };
    "v1.public.user.signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `SignupRequestDto` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SignupRequestDto"];
            };
        };
        responses: {
            /**
             * @description `SignupResponse`
             *
             *     `ValidateSignupResponse`
             */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SignupResponse"] | components["schemas"]["ValidateSignupResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.public.user.get_user_edit_data": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `UserEditDataResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserEditDataResponse"];
                };
            };
        };
    };
    "v1.user.request_user_report_by_user": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `StoreUserReportRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["StoreUserReportRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "The generation of the user report has been queued and will be executed in the background";
                    };
                };
            };
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "You must verify your account to be able to request a user report";
                    };
                };
            };
            422: components["responses"]["ValidationException"];
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "You have already requested a user report within the last 24 hours";
                    };
                };
            };
        };
    };
    "v1.user.get_user_download_by_user": {
        parameters: {
            query?: {
                token?: string;
            };
            header?: never;
            path: {
                /** @description The player report ID */
                playerReport: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.get_user_report_status": {
        parameters: {
            query?: {
                token?: string;
            };
            header?: never;
            path: {
                /** @description The player report ID */
                playerReport: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        link: string;
                        message: string;
                    } | null;
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Token is missing";
                    };
                };
            };
            403: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Token expired";
                    } | {
                        /** @constant */
                        message: "Unauthorized";
                    } | {
                        /** @constant */
                        message: "User does not have access to this report";
                    };
                };
            };
            404: components["responses"]["ModelNotFoundException"];
            410: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Report has been deleted";
                    };
                };
            };
        };
    };
    "v1.public.user.validate_signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `UserSignupDto` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UserSignupDto"];
            };
        };
        responses: {
            /** @description `ValidateSignupResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ValidateSignupResponse"];
                };
            };
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.blocks.get_blocks_for_user": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerBlock"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.blocks.backoffice.remove_block": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                blockId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            /** @description Bad request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @description Error overview. */
                        message: string;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "v1.blocks.backoffice.create_new_cooldown": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        /** @description `NewCooldownRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NewCooldownRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.blocks.backoffice.get_player_blocks": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetBlocksResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetBlocksResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "v1.blocks.cooldown.create_new_cooldown": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        /** @description `NewCooldownRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["NewCooldownRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.blocks.player_block.index": {
        parameters: {
            query?: {
                /**
                 * @description An array of conditions to filter the results by. Each condition is a comma-separated triplet of `field,operator,value`.
                 *     Depending on where you're calling this from, you must adapt the syntax of this parameter. Examples and detailed documentation is provided below.
                 *
                 *     ### Calling from browser or HTTP client
                 *
                 *     If you're calling Player Account directly from the browser (or a HTTP client), each condition consists of the comma-separated parts and multiple conditions are combined with semi-colons (meaning logical AND).
                 *     Examples:
                 *     - ?conditions=age,>=,18
                 *     - ?conditions=status,in,[active|pending|suspended]
                 *     - ?conditions=created_at,between,[2023-01-01|2023-12-31]
                 *     - ?conditions=age,>=,18;status,like,%active%
                 *
                 *     ### Calling from dedoc/scramble docs page
                 *
                 *     If you're exploring the API on dedoc/scrambles API documentations page, you must format the conditions as an array of strings.
                 *     Each entry must hold a comma-separated value of strings.
                 *     Examples:
                 *     - ["sex,=,f","age,>=,18"]
                 *     - ["email,like,%@cego.dk"]
                 *     - ["created,between,2026-03-10|2026-03-14"]
                 *
                 *     ### Supported operators
                 *
                 *     All built-in Eloquent query builder operators are supported, as well as:
                 *     - `like` (SQL LIKE operator)
                 *     - `not_like` (SQL NOT LIKE operator)
                 *     - `in` (value is in a list of values, pipe separated within brackets)
                 *     - `not_in` (value is not in a list of values, pipe separated within brackets)
                 *     - `between` (value is between two values, pipe separated within brackets)
                 *     - `not_between` (value is not between two values, pipe separated within brackets)
                 *
                 *     ### Value format
                 *
                 *     - Simple comparisons expect a single value: `age,>,18`
                 *     - `in` and `not_in` expect a bracket-enclosed pipe-separated list: `status,in,[active|pending|suspended]`
                 *     - `between` and `not_between` expect a bracket-enclosed pipe-separated pair: `created_at,between,[2023-01-01|2023-12-31]`
                 */
                "conditions[]"?: string[];
                /**
                 * @description A comma-separated list of fields to include in the response. If not provided, all fields except optional appends are included.
                 *     If specified, only a subset of fields are included. Each model should document which fields are available when.
                 */
                "fields[]"?: string[];
                /**
                 * @description An array of fields to order the results by. Each order consists of a field and a type (asc or desc). Multiple orders are applied in the order they are given.
                 *     Examples:
                 *     - ?orderBy=created_at,desc
                 *     - ?orderBy=last_name,asc;first_name,asc
                 */
                "orderBy[]"?: string[];
                page?: number;
                perPage?: number;
                /** @description Determines whether to use simple pagination - if true current_page_url is set, otherwise "total", "last_page", "last_page_url" and "links" are set. */
                simplePaginate?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.blocks.remove_all_blocks": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        /** @description `RemoveAllBlocksRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["RemoveAllBlocksRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            /** @description Bad request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @description Error overview. */
                        message: string;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.blocks.get_all_blocks_for_player": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetBlocksResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetBlocksResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "v1.blocks.reconcile": {
        parameters: {
            query: {
                from: string;
                to: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: components["schemas"]["BlockTypeCounts"];
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.data.audits": {
        parameters: {
            query?: {
                from?: string | null;
                properties?: string[] | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserAuditsRepresentation"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.data.blocks": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["BlockRepresentation"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.data.closed_logs": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserClosedLogsRepresentation"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.data.cooldowns": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["CooldownRepresentation"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.data.deactivated_logs": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string[];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.data.event_logs": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerEventLogsRepresentation"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.data.flag_logs": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerFlagLogsRepresentation"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.data.notes": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerNotesRepresentation"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.data.suspension_logs": {
        parameters: {
            query?: {
                from?: string | null;
                to?: string | null;
            };
            header?: never;
            path: {
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": string[];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.flag.index": {
        parameters: {
            query?: {
                /**
                 * @description An array of conditions to filter the results by. Each condition is a comma-separated triplet of `field,operator,value`.
                 *     Depending on where you're calling this from, you must adapt the syntax of this parameter. Examples and detailed documentation is provided below.
                 *
                 *     ### Calling from browser or HTTP client
                 *
                 *     If you're calling Player Account directly from the browser (or a HTTP client), each condition consists of the comma-separated parts and multiple conditions are combined with semi-colons (meaning logical AND).
                 *     Examples:
                 *     - ?conditions=age,>=,18
                 *     - ?conditions=status,in,[active|pending|suspended]
                 *     - ?conditions=created_at,between,[2023-01-01|2023-12-31]
                 *     - ?conditions=age,>=,18;status,like,%active%
                 *
                 *     ### Calling from dedoc/scramble docs page
                 *
                 *     If you're exploring the API on dedoc/scrambles API documentations page, you must format the conditions as an array of strings.
                 *     Each entry must hold a comma-separated value of strings.
                 *     Examples:
                 *     - ["sex,=,f","age,>=,18"]
                 *     - ["email,like,%@cego.dk"]
                 *     - ["created,between,2026-03-10|2026-03-14"]
                 *
                 *     ### Supported operators
                 *
                 *     All built-in Eloquent query builder operators are supported, as well as:
                 *     - `like` (SQL LIKE operator)
                 *     - `not_like` (SQL NOT LIKE operator)
                 *     - `in` (value is in a list of values, pipe separated within brackets)
                 *     - `not_in` (value is not in a list of values, pipe separated within brackets)
                 *     - `between` (value is between two values, pipe separated within brackets)
                 *     - `not_between` (value is not between two values, pipe separated within brackets)
                 *
                 *     ### Value format
                 *
                 *     - Simple comparisons expect a single value: `age,>,18`
                 *     - `in` and `not_in` expect a bracket-enclosed pipe-separated list: `status,in,[active|pending|suspended]`
                 *     - `between` and `not_between` expect a bracket-enclosed pipe-separated pair: `created_at,between,[2023-01-01|2023-12-31]`
                 */
                "conditions[]"?: string[];
                /**
                 * @description A comma-separated list of fields to include in the response. If not provided, all fields except optional appends are included.
                 *     If specified, only a subset of fields are included. Each model should document which fields are available when.
                 */
                "fields[]"?: string[];
                /**
                 * @description An array of fields to order the results by. Each order consists of a field and a type (asc or desc). Multiple orders are applied in the order they are given.
                 *     Examples:
                 *     - ?orderBy=created_at,desc
                 *     - ?orderBy=last_name,asc;first_name,asc
                 */
                "orderBy[]"?: string[];
                /** @description Determines whether to use simple pagination - if true current_page_url is set, otherwise "total", "last_page", "last_page_url" and "links" are set. */
                simplePaginate?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Flag"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.index": {
        parameters: {
            query?: {
                fields?: string[];
                page?: number;
                perPage?: number;
                withNewestUser?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["StorePlayerRequest"];
            };
        };
        responses: {
            /** @description `Player` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never> | components["schemas"]["Player"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player_event_log.store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `StorePlayerEventLogRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["StorePlayerEventLogRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player_flag.index": {
        parameters: {
            query?: {
                /**
                 * @description An array of conditions to filter the results by. Each condition is a comma-separated triplet of `field,operator,value`.
                 *     Depending on where you're calling this from, you must adapt the syntax of this parameter. Examples and detailed documentation is provided below.
                 *
                 *     ### Calling from browser or HTTP client
                 *
                 *     If you're calling Player Account directly from the browser (or a HTTP client), each condition consists of the comma-separated parts and multiple conditions are combined with semi-colons (meaning logical AND).
                 *     Examples:
                 *     - ?conditions=age,>=,18
                 *     - ?conditions=status,in,[active|pending|suspended]
                 *     - ?conditions=created_at,between,[2023-01-01|2023-12-31]
                 *     - ?conditions=age,>=,18;status,like,%active%
                 *
                 *     ### Calling from dedoc/scramble docs page
                 *
                 *     If you're exploring the API on dedoc/scrambles API documentations page, you must format the conditions as an array of strings.
                 *     Each entry must hold a comma-separated value of strings.
                 *     Examples:
                 *     - ["sex,=,f","age,>=,18"]
                 *     - ["email,like,%@cego.dk"]
                 *     - ["created,between,2026-03-10|2026-03-14"]
                 *
                 *     ### Supported operators
                 *
                 *     All built-in Eloquent query builder operators are supported, as well as:
                 *     - `like` (SQL LIKE operator)
                 *     - `not_like` (SQL NOT LIKE operator)
                 *     - `in` (value is in a list of values, pipe separated within brackets)
                 *     - `not_in` (value is not in a list of values, pipe separated within brackets)
                 *     - `between` (value is between two values, pipe separated within brackets)
                 *     - `not_between` (value is not between two values, pipe separated within brackets)
                 *
                 *     ### Value format
                 *
                 *     - Simple comparisons expect a single value: `age,>,18`
                 *     - `in` and `not_in` expect a bracket-enclosed pipe-separated list: `status,in,[active|pending|suspended]`
                 *     - `between` and `not_between` expect a bracket-enclosed pipe-separated pair: `created_at,between,[2023-01-01|2023-12-31]`
                 */
                "conditions[]"?: string[];
                /**
                 * @description A comma-separated list of fields to include in the response. If not provided, all fields except optional appends are included.
                 *     If specified, only a subset of fields are included. Each model should document which fields are available when.
                 */
                "fields[]"?: string[];
                /**
                 * @description An array of fields to order the results by. Each order consists of a field and a type (asc or desc). Multiple orders are applied in the order they are given.
                 *     Examples:
                 *     - ?orderBy=created_at,desc
                 *     - ?orderBy=last_name,asc;first_name,asc
                 */
                "orderBy[]"?: string[];
                page?: number;
                perPage?: number;
                /** @description Determines whether to use simple pagination - if true current_page_url is set, otherwise "total", "last_page", "last_page_url" and "links" are set. */
                simplePaginate?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player_flag_log.index": {
        parameters: {
            query?: {
                /**
                 * @description An array of conditions to filter the results by. Each condition is a comma-separated triplet of `field,operator,value`.
                 *     Depending on where you're calling this from, you must adapt the syntax of this parameter. Examples and detailed documentation is provided below.
                 *
                 *     ### Calling from browser or HTTP client
                 *
                 *     If you're calling Player Account directly from the browser (or a HTTP client), each condition consists of the comma-separated parts and multiple conditions are combined with semi-colons (meaning logical AND).
                 *     Examples:
                 *     - ?conditions=age,>=,18
                 *     - ?conditions=status,in,[active|pending|suspended]
                 *     - ?conditions=created_at,between,[2023-01-01|2023-12-31]
                 *     - ?conditions=age,>=,18;status,like,%active%
                 *
                 *     ### Calling from dedoc/scramble docs page
                 *
                 *     If you're exploring the API on dedoc/scrambles API documentations page, you must format the conditions as an array of strings.
                 *     Each entry must hold a comma-separated value of strings.
                 *     Examples:
                 *     - ["sex,=,f","age,>=,18"]
                 *     - ["email,like,%@cego.dk"]
                 *     - ["created,between,2026-03-10|2026-03-14"]
                 *
                 *     ### Supported operators
                 *
                 *     All built-in Eloquent query builder operators are supported, as well as:
                 *     - `like` (SQL LIKE operator)
                 *     - `not_like` (SQL NOT LIKE operator)
                 *     - `in` (value is in a list of values, pipe separated within brackets)
                 *     - `not_in` (value is not in a list of values, pipe separated within brackets)
                 *     - `between` (value is between two values, pipe separated within brackets)
                 *     - `not_between` (value is not between two values, pipe separated within brackets)
                 *
                 *     ### Value format
                 *
                 *     - Simple comparisons expect a single value: `age,>,18`
                 *     - `in` and `not_in` expect a bracket-enclosed pipe-separated list: `status,in,[active|pending|suspended]`
                 *     - `between` and `not_between` expect a bracket-enclosed pipe-separated pair: `created_at,between,[2023-01-01|2023-12-31]`
                 */
                "conditions[]"?: string[];
                /**
                 * @description A comma-separated list of fields to include in the response. If not provided, all fields except optional appends are included.
                 *     If specified, only a subset of fields are included. Each model should document which fields are available when.
                 */
                "fields[]"?: string[];
                /**
                 * @description An array of fields to order the results by. Each order consists of a field and a type (asc or desc). Multiple orders are applied in the order they are given.
                 *     Examples:
                 *     - ?orderBy=created_at,desc
                 *     - ?orderBy=last_name,asc;first_name,asc
                 */
                "orderBy[]"?: string[];
                page?: number;
                perPage?: number;
                /** @description Determines whether to use simple pagination - if true current_page_url is set, otherwise "total", "last_page", "last_page_url" and "links" are set. */
                simplePaginate?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player_flag.destroy": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player flag ID */
                playerFlag: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.player.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `Player` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Player"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.exclusion.get_status": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `ExclusionStatusResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ExclusionStatusResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.player.flag.add": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserFlagRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.flag.remove": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserFlagRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.flag.get_flags": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Flag"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.player.flag.has_flag": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                flagType: string;
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        has_flag: boolean;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.player.flag.has_had": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                flagType: string;
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `HasHadFlagResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HasHadFlagResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.player.get_all_users": {
        parameters: {
            query?: {
                /**
                 * @description An array of conditions to filter the results by. Each condition is a comma-separated triplet of `field,operator,value`.
                 *     Depending on where you're calling this from, you must adapt the syntax of this parameter. Examples and detailed documentation is provided below.
                 *
                 *     ### Calling from browser or HTTP client
                 *
                 *     If you're calling Player Account directly from the browser (or a HTTP client), each condition consists of the comma-separated parts and multiple conditions are combined with semi-colons (meaning logical AND).
                 *     Examples:
                 *     - ?conditions=age,>=,18
                 *     - ?conditions=status,in,[active|pending|suspended]
                 *     - ?conditions=created_at,between,[2023-01-01|2023-12-31]
                 *     - ?conditions=age,>=,18;status,like,%active%
                 *
                 *     ### Calling from dedoc/scramble docs page
                 *
                 *     If you're exploring the API on dedoc/scrambles API documentations page, you must format the conditions as an array of strings.
                 *     Each entry must hold a comma-separated value of strings.
                 *     Examples:
                 *     - ["sex,=,f","age,>=,18"]
                 *     - ["email,like,%@cego.dk"]
                 *     - ["created,between,2026-03-10|2026-03-14"]
                 *
                 *     ### Supported operators
                 *
                 *     All built-in Eloquent query builder operators are supported, as well as:
                 *     - `like` (SQL LIKE operator)
                 *     - `not_like` (SQL NOT LIKE operator)
                 *     - `in` (value is in a list of values, pipe separated within brackets)
                 *     - `not_in` (value is not in a list of values, pipe separated within brackets)
                 *     - `between` (value is between two values, pipe separated within brackets)
                 *     - `not_between` (value is not between two values, pipe separated within brackets)
                 *
                 *     ### Value format
                 *
                 *     - Simple comparisons expect a single value: `age,>,18`
                 *     - `in` and `not_in` expect a bracket-enclosed pipe-separated list: `status,in,[active|pending|suspended]`
                 *     - `between` and `not_between` expect a bracket-enclosed pipe-separated pair: `created_at,between,[2023-01-01|2023-12-31]`
                 */
                "conditions[]"?: string[];
                /**
                 * @description A comma-separated list of fields to include in the response. If not provided, all fields except optional appends are included.
                 *     If specified, only a subset of fields are included. Each model should document which fields are available when.
                 */
                "fields[]"?: string[];
                /**
                 * @description An array of fields to order the results by. Each order consists of a field and a type (asc or desc). Multiple orders are applied in the order they are given.
                 *     Examples:
                 *     - ?orderBy=created_at,desc
                 *     - ?orderBy=last_name,asc;first_name,asc
                 */
                "orderBy[]"?: string[];
                /** @description Determines whether to use simple pagination - if true current_page_url is set, otherwise "total", "last_page", "last_page_url" and "links" are set. */
                simplePaginate?: boolean;
            };
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegacyUser"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.get_newest_user": {
        parameters: {
            query?: {
                fields?: string[];
            };
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.get_oldest_user": {
        parameters: {
            query?: {
                fields?: string[];
            };
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.get_users_count": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        count: number;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.player.get_active_user": {
        parameters: {
            query?: {
                fields?: string[];
            };
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.notes.store": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        /** @description `StorePlayerNoteRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["StorePlayerNoteRequest"];
            };
        };
        responses: {
            /** @description `PlayerNotesRepresentation` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerNotesRepresentation"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.get_all_player_event_logs_for_player": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerEventLog"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.player.flag.batch_add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `BatchPlayerFlagRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchPlayerFlagRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.flag.batch_remove": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `BatchPlayerFlagRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchPlayerFlagRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.get_newest_users": {
        parameters: {
            query: {
                "fields[]"?: string[];
                "player_ids[]": string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    }[];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.store_occupation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `OccupationRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["OccupationRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        saved_occupation: string;
                    };
                };
            };
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Invalid occupation provided.";
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.get_occupations": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        occupations: string;
                        /** Format: uuid */
                        player_id: string;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.player.occupation.get_occupation_types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        [key: string]: unknown;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "v1.player.store_salary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `SalaryRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SalaryRequest"];
            };
        };
        responses: {
            /** @description `StoreSalaryResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StoreSalaryResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.player.get_salary": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GetSalaryResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetSalaryResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.player.salary.get_salary_types": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GetSalaryOptionsResponse"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "v1.segment.index": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Segment"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "v1.segment.show": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `Segment` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Segment"];
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "v1.segment.player.remove_segment": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
                type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.segment.players_count": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                type: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        player_count: number;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "v1.segment.user.remove_segment": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                type: string;
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.segment.player.batch_add_segment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchPlayerSegmentRequest"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Succesfully added segment to players";
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.segment.player.get_segments": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Segment"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.segment.player.add_segment": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player ID */
                player: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SegmentRequest"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Succesfully added segment to player";
                    };
                };
            };
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Player already had segment";
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.segment.user.batch_add_segment": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchUserSegmentRequest"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Succesfully added segment to users";
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.segment.user.get_segments": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Segment"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.segment.user.add_segment": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SegmentRequest"];
            };
        };
        responses: {
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Succesfully added segment to user";
                    };
                };
            };
            /** @description No content */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "User already had segment";
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.index": {
        parameters: {
            query?: {
                /**
                 * @description An array of conditions to filter the results by. Each condition is a comma-separated triplet of `field,operator,value`.
                 *     Depending on where you're calling this from, you must adapt the syntax of this parameter. Examples and detailed documentation is provided below.
                 *
                 *     ### Calling from browser or HTTP client
                 *
                 *     If you're calling Player Account directly from the browser (or a HTTP client), each condition consists of the comma-separated parts and multiple conditions are combined with semi-colons (meaning logical AND).
                 *     Examples:
                 *     - ?conditions=age,>=,18
                 *     - ?conditions=status,in,[active|pending|suspended]
                 *     - ?conditions=created_at,between,[2023-01-01|2023-12-31]
                 *     - ?conditions=age,>=,18;status,like,%active%
                 *
                 *     ### Calling from dedoc/scramble docs page
                 *
                 *     If you're exploring the API on dedoc/scrambles API documentations page, you must format the conditions as an array of strings.
                 *     Each entry must hold a comma-separated value of strings.
                 *     Examples:
                 *     - ["sex,=,f","age,>=,18"]
                 *     - ["email,like,%@cego.dk"]
                 *     - ["created,between,2026-03-10|2026-03-14"]
                 *
                 *     ### Supported operators
                 *
                 *     All built-in Eloquent query builder operators are supported, as well as:
                 *     - `like` (SQL LIKE operator)
                 *     - `not_like` (SQL NOT LIKE operator)
                 *     - `in` (value is in a list of values, pipe separated within brackets)
                 *     - `not_in` (value is not in a list of values, pipe separated within brackets)
                 *     - `between` (value is between two values, pipe separated within brackets)
                 *     - `not_between` (value is not between two values, pipe separated within brackets)
                 *
                 *     ### Value format
                 *
                 *     - Simple comparisons expect a single value: `age,>,18`
                 *     - `in` and `not_in` expect a bracket-enclosed pipe-separated list: `status,in,[active|pending|suspended]`
                 *     - `between` and `not_between` expect a bracket-enclosed pipe-separated pair: `created_at,between,[2023-01-01|2023-12-31]`
                 */
                "conditions[]"?: string[];
                /**
                 * @description A comma-separated list of fields to include in the response. If not provided, all fields except optional appends are included.
                 *     If specified, only a subset of fields are included. Each model should document which fields are available when.
                 */
                "fields[]"?: string[];
                /**
                 * @description An array of fields to order the results by. Each order consists of a field and a type (asc or desc). Multiple orders are applied in the order they are given.
                 *     Examples:
                 *     - ?orderBy=created_at,desc
                 *     - ?orderBy=last_name,asc;first_name,asc
                 */
                "orderBy[]"?: string[];
                page?: number;
                perPage?: number;
                /** @description Determines whether to use simple pagination - if true current_page_url is set, otherwise "total", "last_page", "last_page_url" and "links" are set. */
                simplePaginate?: boolean;
                withClosedUsers?: boolean;
                /**
                 * @description Only find users that has at least one of the given site flags.
                 *     Example: ?withFlags=ChatBan,UserAllowedToBypassOcesLogin
                 */
                "withFlags[]"?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /**
             * @description Paginated set of `UserRepresentation`
             *
             *     Paginated set of `UserRepresentation`
             */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        current_page: number;
                        data: components["schemas"]["UserRepresentation"][];
                        first_page_url: string | null;
                        from: number | null;
                        next_page_url: string | null;
                        /** @description Base path for paginator generated URLs. */
                        path: string | null;
                        /** @description Number of items shown per page. */
                        per_page: number;
                        prev_page_url: string | null;
                        /** @description Number of the last item in the slice. */
                        to: number | null;
                    } | {
                        current_page: number;
                        data: components["schemas"]["UserRepresentation"][];
                        first_page_url: string | null;
                        from: number | null;
                        last_page: number;
                        last_page_url: string | null;
                        /** @description Generated paginator links. */
                        links: {
                            active: boolean;
                            label: string;
                            url: string | null;
                        }[];
                        next_page_url: string | null;
                        /** @description Base path for paginator generated URLs. */
                        path: string | null;
                        /** @description Number of items shown per page. */
                        per_page: number;
                        prev_page_url: string | null;
                        /** @description Number of the last item in the slice. */
                        to: number | null;
                        /** @description Total number of items being paginated. */
                        total: number;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user_brand.get": {
        parameters: {
            query: {
                userIds: number[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserBrandResponse"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user_brand.newest_users": {
        parameters: {
            query?: {
                brand?: components["schemas"]["Brand"] | null;
                from?: string | null;
                page?: number;
                perPage?: number;
                sortOrder?: string;
                to?: string | null;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Paginated set of `UserBrand` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        current_page: number;
                        data: components["schemas"]["UserBrand"][];
                        first_page_url: string | null;
                        from: number | null;
                        last_page: number;
                        last_page_url: string | null;
                        /** @description Generated paginator links. */
                        links: {
                            active: boolean;
                            label: string;
                            url: string | null;
                        }[];
                        next_page_url: string | null;
                        /** @description Base path for paginator generated URLs. */
                        path: string | null;
                        /** @description Number of items shown per page. */
                        per_page: number;
                        prev_page_url: string | null;
                        /** @description Number of the last item in the slice. */
                        to: number | null;
                        /** @description Total number of items being paginated. */
                        total: number;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.show": {
        parameters: {
            query?: {
                "fields[]"?: string[];
            };
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `UserRepresentation` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserRepresentation"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.update": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["UpdateUserRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.accountStatusReport": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    "Content-Disposition"?: string;
                    [name: string]: unknown;
                };
                content: {
                    "application/pdf": string;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.flag.get_event_logs": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerEventLog"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.flag.get_user_flag_data": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserFlagDataRepresentation"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.flag_logs_data": {
        parameters: {
            query?: {
                conditions?: {
                    field?: string;
                    operator?: string;
                    value?: string;
                }[];
                "fields[]"?: string[];
                orderBy?: {
                    field?: string;
                    /** @enum {string} */
                    type?: PathsV1UserUserFlagLogsDataGetParametersQueryOrderByType;
                }[];
            };
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["PlayerFlagLog"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.flag.add": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserFlagRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.flag.batch_add_to_user": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchFlagsRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.flag.batch_remove_from_user": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchFlagsRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.flag.remove": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserFlagRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.flag.get_flags": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.flag.has_had": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                flagType: string;
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `HasHadFlagResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HasHadFlagResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.get_all_users_from_player": {
        parameters: {
            query?: {
                "fields[]"?: string[];
            };
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LegacyUser"][];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.incident.store": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserIncidentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.payout_block": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        is_blocked: boolean;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.get_all_user_reports_for_user": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        reports: components["schemas"]["PlayerReport"][];
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.admin.request_user_report": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        /** @description `PlayerReportByAdminRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["PlayerReportByAdminRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "The generation of the user report has been queued and will be executed in the background";
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "A user report has already been requested by an admin user within the last 5 minutes";
                    };
                };
            };
        };
    };
    "v1.user.get_user_report": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The player report ID */
                playerReport: number;
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.signed_up": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        /** @description `UserSignedUpRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserSignedUpRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** Format: uuid */
                        player_id: string;
                        success: boolean;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.get_similar_users": {
        parameters: {
            query?: {
                comparingTopResults?: number;
                dryRun?: boolean;
                thresholdPercentage?: number;
            };
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @constant */
                        message: "Similarity check has been queued, and will soon be executed in the background.";
                        success: boolean;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.updateUserValidationStatus": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        /** @description `UpdateUserValidationStatusRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UpdateUserValidationStatusRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.username.generate": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The user ID */
                user: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `GeneratedUsernameResponse` */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GeneratedUsernameResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            404: components["responses"]["ModelNotFoundException"];
        };
    };
    "v1.user.acl_attributes": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description `UserAclAttributes` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserAclAttributes"];
                };
            };
            403: components["responses"]["AuthorizationException"];
        };
    };
    "v1.user.batch": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `UserBatchRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserBatchRequest"];
            };
        };
        responses: {
            /** @description `UserBatchResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["UserBatchResponse"];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.flag.batch_add": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchUserFlagRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.flag.batch_remove": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchUserFlagRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.fullyAnonymized": {
        parameters: {
            query?: {
                cursor?: string | null;
                perPage?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.incident.batch_store": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchUserIncidentRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.indexWithFlags": {
        parameters: {
            query?: {
                /**
                 * @description An array of conditions to filter the results by. Each condition is a comma-separated triplet of `field,operator,value`.
                 *     Depending on where you're calling this from, you must adapt the syntax of this parameter. Examples and detailed documentation is provided below.
                 *
                 *     ### Calling from browser or HTTP client
                 *
                 *     If you're calling Player Account directly from the browser (or a HTTP client), each condition consists of the comma-separated parts and multiple conditions are combined with semi-colons (meaning logical AND).
                 *     Examples:
                 *     - ?conditions=age,>=,18
                 *     - ?conditions=status,in,[active|pending|suspended]
                 *     - ?conditions=created_at,between,[2023-01-01|2023-12-31]
                 *     - ?conditions=age,>=,18;status,like,%active%
                 *
                 *     ### Calling from dedoc/scramble docs page
                 *
                 *     If you're exploring the API on dedoc/scrambles API documentations page, you must format the conditions as an array of strings.
                 *     Each entry must hold a comma-separated value of strings.
                 *     Examples:
                 *     - ["sex,=,f","age,>=,18"]
                 *     - ["email,like,%@cego.dk"]
                 *     - ["created,between,2026-03-10|2026-03-14"]
                 *
                 *     ### Supported operators
                 *
                 *     All built-in Eloquent query builder operators are supported, as well as:
                 *     - `like` (SQL LIKE operator)
                 *     - `not_like` (SQL NOT LIKE operator)
                 *     - `in` (value is in a list of values, pipe separated within brackets)
                 *     - `not_in` (value is not in a list of values, pipe separated within brackets)
                 *     - `between` (value is between two values, pipe separated within brackets)
                 *     - `not_between` (value is not between two values, pipe separated within brackets)
                 *
                 *     ### Value format
                 *
                 *     - Simple comparisons expect a single value: `age,>,18`
                 *     - `in` and `not_in` expect a bracket-enclosed pipe-separated list: `status,in,[active|pending|suspended]`
                 *     - `between` and `not_between` expect a bracket-enclosed pipe-separated pair: `created_at,between,[2023-01-01|2023-12-31]`
                 */
                "conditions[]"?: string[];
                current_page?: number;
                /**
                 * @description A comma-separated list of fields to include in the response. If not provided, all fields except optional appends are included.
                 *     If specified, only a subset of fields are included. Each model should document which fields are available when.
                 */
                "fields[]"?: string[];
                /**
                 * @description An array of fields to order the results by. Each order consists of a field and a type (asc or desc). Multiple orders are applied in the order they are given.
                 *     Examples:
                 *     - ?orderBy=created_at,desc
                 *     - ?orderBy=last_name,asc;first_name,asc
                 */
                "orderBy[]"?: string[];
                page?: number;
                perPage?: number;
                /** @description Determines whether to use simple pagination - if true current_page_url is set, otherwise "total", "last_page", "last_page_url" and "links" are set. */
                simplePaginate?: boolean;
                withClosedUsers?: boolean;
                /**
                 * @description Only find users that has at least one of the given site flags.
                 *     Example: ?withFlags=ChatBan,UserAllowedToBypassOcesLogin
                 */
                "withFlags[]"?: string[];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /**
             * @description Paginated set of `LegacyUser`
             *
             *     Paginated set of `LegacyUser`
             */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        current_page: number;
                        data: components["schemas"]["LegacyUser"][];
                        first_page_url: string | null;
                        from: number | null;
                        last_page: number;
                        last_page_url: string | null;
                        /** @description Generated paginator links. */
                        links: {
                            active: boolean;
                            label: string;
                            url: string | null;
                        }[];
                        next_page_url: string | null;
                        /** @description Base path for paginator generated URLs. */
                        path: string | null;
                        /** @description Number of items shown per page. */
                        per_page: number;
                        prev_page_url: string | null;
                        /** @description Number of the last item in the slice. */
                        to: number | null;
                        /** @description Total number of items being paginated. */
                        total: number;
                    } | {
                        current_page: number;
                        data: components["schemas"]["LegacyUser"][];
                        first_page_url: string | null;
                        from: number | null;
                        next_page_url: string | null;
                        /** @description Base path for paginator generated URLs. */
                        path: string | null;
                        /** @description Number of items shown per page. */
                        per_page: number;
                        prev_page_url: string | null;
                        /** @description Number of the last item in the slice. */
                        to: number | null;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.search": {
        parameters: {
            query: {
                search: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        address: string | null;
                        anonymized: boolean | null;
                        birthdate: string | null;
                        city: string | null;
                        closed: boolean;
                        /** Format: date-time */
                        created: string;
                        customer_number: string;
                        email: string;
                        first_name: string | null;
                        id: number;
                        is_staff: number | null;
                        /** Format: date-time */
                        last_login: string | null;
                        last_name: string | null;
                        /** Format: date-time */
                        modified: string;
                        name: string;
                        phone: string | null;
                        phone_prefix: string;
                        /** Format: uuid */
                        player_id: string | null;
                        sex: string | null;
                        ssn: string;
                        user_validation_status_id: number;
                        zipcode: string | null;
                    }[];
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `BackendSignupRequestDto` */
        requestBody?: {
            content: {
                "application/json": components["schemas"]["BackendSignupRequestDto"];
            };
        };
        responses: {
            /** @description `ValidateSignupResponse` */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ValidateSignupResponse"];
                };
            };
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        player_id: string;
                        user_id: string;
                    };
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.batch_update": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BatchUpdateUserRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
    "v1.user.validate_signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description `UserSignupValidationRequest` */
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserSignupValidationRequest"];
            };
        };
        responses: {
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": Record<string, never>;
                };
            };
            403: components["responses"]["AuthorizationException"];
            422: components["responses"]["ValidationException"];
        };
    };
}
export enum PathsV1UserUserFlagLogsDataGetParametersQueryOrderByType {
    asc = "asc",
    desc = "desc",
    ASC = "ASC",
    DESC = "DESC"
}
export enum BlockCategory {
    legacy = "legacy",
    manual = "manual",
    self_exclusion = "self-exclusion",
    mentor = "mentor",
    one_month_unconfirmed = "one-month-unconfirmed",
    inactivity = "inactivity",
    cpr_validation_failed = "cpr-validation-failed",
    multi_accounting = "multi-accounting",
    multi_accounting_in_gamstop = "multi-accounting-in-gamstop",
    pep = "pep",
    sanctioned = "sanctioned",
    underage = "underage",
    unvalidated_period_expired = "unvalidated-period-expired",
    game_scanner = "game-scanner",
    missing_source_of_funds = "missing-source-of-funds",
    missing_additional_information = "missing-additional-information",
    missing_proof_of_ownership = "missing-proof-of-ownership",
    chargeback = "chargeback",
    fraud = "fraud",
    excluded_by_gambling_authority = "excluded-by-gambling-authority",
    aml = "aml",
    failed_deposits = "failed-deposits"
}
export enum BlockDuration {
    two_hours = "two-hours",
    end_of_day = "end-of-day",
    one_day = "one-day",
    one_week = "one-week",
    two_weeks = "two-weeks",
    one_month = "one-month",
    six_weeks = "six-weeks",
    six_months = "six-months",
    one_year = "one-year",
    two_years = "two-years",
    three_years = "three-years",
    four_years = "four-years",
    five_years = "five-years",
    indefinite = "indefinite"
}
export enum BlockType {
    block = "block",
    cooldown = "cooldown",
    deactivation = "deactivation",
    suspension = "suspension"
}
export enum Brand {
    spilnu = "spilnu",
    happytiger = "happytiger",
    spinking = "spinking",
    bingoburst = "bingoburst",
    luxcasino = "luxcasino",
    sweetspin = "sweetspin",
    jackpotfisher = "jackpotfisher",
    spinnow = "spinnow",
    crushit = "crushit"
}
export enum ContactType {
    email = "email",
    phone = "phone"
}
export enum PlayerEventLogType {
    Value3 = 3,
    Value4 = 4,
    Value5 = 5,
    Value6 = 6,
    Value7 = 7,
    Value8 = 8,
    Value9 = 9,
    Value10 = 10,
    Value11 = 11,
    Value12 = 12,
    Value13 = 13,
    Value14 = 14,
    Value15 = 15,
    Value16 = 16,
    Value17 = 17,
    Value18 = 18,
    Value19 = 19,
    Value20 = 20
}
export enum PlayerFlagLogType {
    Value1 = 1,
    Value2 = 2
}
export enum PlayerReportStateTypes {
    unprocessed = "unprocessed",
    processing = "processing",
    processed = "processed",
    downloaded = "downloaded",
    failed = "failed"
}
export enum PublicErrorCodes {
    PA_1100 = "PA:1100",
    PA_1101 = "PA:1101",
    PA_1102 = "PA:1102",
    PA_1103 = "PA:1103",
    PA_1200 = "PA:1200",
    PA_1201 = "PA:1201",
    PA_1202 = "PA:1202",
    PA_1203 = "PA:1203",
    PA_1205 = "PA:1205",
    PA_1206 = "PA:1206",
    PA_1300 = "PA:1300",
    PA_1301 = "PA:1301",
    PA_1400 = "PA:1400",
    PA_1500 = "PA:1500",
    PA_1501 = "PA:1501",
    PA_1502 = "PA:1502",
    PA_1503 = "PA:1503",
    PA_1504 = "PA:1504"
}
export enum UserCheckResultType {
    suspended = "suspended",
    suspended_missing_sof = "suspended-missing-sof",
    deactivated = "deactivated",
    block = "block",
    expired_block_must_be_removed_by_customer_service = "expired-block-must-be-removed-by-customer_service",
    cooldown = "cooldown",
    gdc_check_failed = "gdc-check-failed",
    extended_kyc_check_required = "extended-kyc-check-required",
    oces_login_required = "oces-login-required",
    multi_account = "multi-account"
}
export enum UserValidationStatus {
    Value1 = 1,
    Value2 = 2,
    Value3 = 3,
    Value4 = 4,
    Value5 = 5
}
